import { useQuery } from '@tanstack/react-query';

import { api } from '../../api/client';
import { lire } from '../../api/call';
import type { components } from '../../api/schema';
import { useSession } from '../../auth/AuthProvider';

export type ModuleCatalogue = components['schemas']['CatalogModule'];
export type CoachCatalogue = components['schemas']['CatalogCoach'];
export type Coach = components['schemas']['Coach'];
export type SourcePrompt = components['schemas']['PromptSource'];

/** Modules et coachs dans l'ordre d'affichage (sans les prompts). */
export function useCatalogue() {
  return useQuery({ queryKey: ['catalogue'], queryFn: async () => (await lire(api.GET('/api/admin/catalog'))).modules });
}

export function useCoach(id: string) {
  return useQuery({
    queryKey: ['coach', id],
    queryFn: async () => (await lire(api.GET('/api/admin/catalog/coaches/{id}', { params: { path: { id } } }))).coach,
    enabled: !!id,
  });
}

/** Contenus IA : seul le super admin modifie (cahier des charges §3). */
export function useEcritureContenus(): boolean {
  return useSession().user?.isSuperAdmin ?? false;
}

export const LIBELLE_SOURCE: Record<SourcePrompt, string> = {
  backoffice: 'Back-office',
  ancien_backoffice: 'Ancien back-office',
  restauration: 'Restauration',
  initiale: 'Version d’origine',
};

/** Déplace `id` à la position `vers` (liste d'identifiants). */
export function deplacer(ids: string[], id: string, vers: number): string[] {
  const reste = ids.filter((x) => x !== id);
  const cible = Math.max(0, Math.min(reste.length, vers));
  return [...reste.slice(0, cible), id, ...reste.slice(cible)];
}

export function initiales(nom: string): string {
  return nom
    .replace(/^(le|la|l’|l')\s*/i, '')
    .split(/\s+/)
    .filter((m) => /^[\p{L}\p{N}]/u.test(m))
    .slice(0, 2)
    .map((m) => m[0]!.toUpperCase())
    .join('');
}
